module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-4.jpg?14ba699b";